import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';

import { Stack } from 'react-spark';

import { OffersV3Header } from './OffersV3Header';
import { OffersV3SingleOfferTerm } from './OffersV3SingleOfferTerm';
import { OffersV3Help } from './OffersV3Help';
import { OffersV3Disclaimer } from './OffersV3Disclaimer';
import { OffersV3Customize } from './OffersV3Customize';
import CreditCardReductionBanner from '../../banners/CreditCardReductionBanner';

export class OffersV3Layout extends Component {
    static propTypes = {
        firstName: PropTypes.string,
        maxOffer: PropTypes.number.isRequired,
        minOffer: PropTypes.number,
        customizedOffer: PropTypes.number.isRequired,
        counterOffer: PropTypes.bool,
        counterOfferReportChanged: PropTypes.bool,
        isTeamMember: PropTypes.bool.isRequired,
        hasQlDiscount: PropTypes.bool,
        getsRLReturningClientDiscount: PropTypes.bool.isRequired,
        autoPayDiscountConfig: PropTypes.object,
        clientStateMinAmount: PropTypes.number,
        requestedAmountAvailable: PropTypes.bool,
    };


    constructor(props) {
        super(props);
        this.state = {
            isV3CustomizeModalOpen: false,
        };
    }

    handleV3AdjustAmountClick = () => {
        this.setState({ isV3CustomizeModalOpen: true });
    };

    handleV3CloseModal = () => {
        this.setState({ isV3CustomizeModalOpen: false });
    };

    render() {
        const {
            firstName,
            maxOffer,
            minOffer,
            customizedOffer,
            counterOffer,
            counterOfferReportChanged,
            isTeamMember,
            hasQlDiscount,
            getsRLReturningClientDiscount,
            autoPayDiscountConfig,
            clientStateMinAmount,
            requestedAmountAvailable,
        } = this.props;

        return (
            <Fragment>
                <CreditCardReductionBanner />
                <div className="offers-v3-gradient-background"></div>
                <div
                    className="offers-page-container"
                    style={{ maxWidth: '508px', margin: '0 auto', position: 'relative', zIndex: 1 }}
                    >
                    <Stack itemSpacing='large'>
                        <Stack.Item className="sprk-u-PaddingHorizontal--a">
                            <OffersV3Header
                                firstName={firstName}
                                maxOffer={maxOffer}
                                minOffer={minOffer}
                                selectedOffer={customizedOffer}
                                counterOffer={counterOffer}
                                counterOfferReportChanged={counterOfferReportChanged}
                                onAdjustAmountClick={this.handleV3AdjustAmountClick}
                            />
                        </Stack.Item>
                        <Stack.Item className="sprk-u-PaddingHorizontal--a">
                            <OffersV3SingleOfferTerm
                                customizedOffer={customizedOffer}
                                isTeamMember={isTeamMember}
                                maxOffer={maxOffer}
                                hasQlDiscount={hasQlDiscount}
                                getsRLReturningClientDiscount={getsRLReturningClientDiscount}
                                autoPayDiscountConfig={autoPayDiscountConfig}
                            />
                        </Stack.Item>
                        <Stack.Item className="sprk-u-PaddingHorizontal--a">
                            <OffersV3Disclaimer />
                        </Stack.Item>
                        <Stack.Item className="sprk-u-PaddingHorizontal--a sprk-u-pbh">
                            <OffersV3Help />
                        </Stack.Item>
                    </Stack>
                </div>
                <OffersV3Customize
                    clientStateMinAmount={clientStateMinAmount}
                    customizedOffer={customizedOffer}
                    maxOffer={maxOffer}
                    minOffer={minOffer}
                    isModalOpen={this.state.isV3CustomizeModalOpen}
                    onCloseModal={this.handleV3CloseModal}
                    requestedAmountAvailable={requestedAmountAvailable}
                />
                <div
                    className="top-anchor"
                    onClick={() => window.scrollTo({
                        top: document.getElementById('customize-offers').offsetTop - document.getElementsByClassName('sprk-c-Masthead')[0].offsetHeight,
                        behavior: 'smooth'
                    })}>
                </div>
            </Fragment>
        );
    }
}

export default OffersV3Layout;
